/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCountryEnum } from './addressCountryEnum';

export interface TeacherRegistrationKindergarten { 
    /**
     * Uživatelský název pracoviště
     */
    name?: string;
    /**
     * IZO
     */
    izo?: string;
    /**
     * Ulice a číslo
     */
    addressStreet?: string;
    /**
     * Obec
     */
    addressCity?: string;
    /**
     * Okres
     */
    addressDistrict?: string;
    /**
     * PSČ
     */
    addressPostcode?: string;
    addressCountry?: AddressCountryEnum;
    /**
     * Primární pracoviště
     */
    isPrimary?: boolean;
}